import '../../sass/plugins/video_plugin.scss';
import { callOnce } from '../utils/initialize';

$(() => {
  const $videoPlugins = $('.video-plugin--remote');

  const initializeRemoteVideoPlayer = (element) => {
    const $element = $(element);
    const $videoPlayer = $element.find('iframe.video-plugin__player--remote');
    const $videoPlayerModal = $element.find('.video-plugin__modal');

    const setNoCookiesYoutubeVideo = () => {
      const videoPlayerSrc = $videoPlayer.attr('src');
      const videoPlayerSrcNoCookies = videoPlayerSrc.replace(
        'youtube.com/',
        'youtube-nocookie.com/'
      );
      $videoPlayer.attr('src', videoPlayerSrcNoCookies);
    };

    const playVideo = () => {
      const videoPlayerSrc = $videoPlayer.attr('src');
      const videoPlayerSrcWithAutoplay = `${videoPlayerSrc}?autoplay=1`;
      $videoPlayer.attr('src', videoPlayerSrcWithAutoplay);
    };

    const stopVideo = () => {
      const videoPlayerSrc = $videoPlayer.attr('src');
      const videoPlayerSrcWithoutAutoplay = videoPlayerSrc.replace(
        '?autoplay=1',
        ''
      );
      $videoPlayer.attr('src', videoPlayerSrcWithoutAutoplay);
    };

    const onClickOnModal = ($event) => {
      const videoPlayerElement = $videoPlayer.get(0);
      if ($event.target !== videoPlayerElement) {
        $videoPlayerModal.modal('hide');
      }
    };

    setNoCookiesYoutubeVideo();

    $videoPlayerModal.on('show.bs.modal', playVideo);
    $videoPlayerModal.on('hidden.bs.modal', stopVideo);
    $videoPlayerModal.on('click', onClickOnModal);
  };

  const initializeAllRemotePlayers = () => {
    $videoPlugins.each((_, element) => initializeRemoteVideoPlayer(element));
  };

  callOnce(initializeAllRemotePlayers);
});
